module.exports = __webpack_public_path__ + "img/credit-card-download.b6cafe6c.svg";